"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var DialogContent_base_1 = require("./DialogContent.base");
var DialogContent_styles_1 = require("./DialogContent.styles");
exports.DialogContent = Utilities_1.styled(DialogContent_base_1.DialogContentBase, DialogContent_styles_1.getStyles);
//# sourceMappingURL=DialogContent.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Dialog/DialogContent.js
// module id = 397
// module chunks = 0